import React from "react";

interface TotalPointsEarnedCardProps {
    totalPoints: number;
}

const TotalPointsEarnedCard: React.FC<TotalPointsEarnedCardProps> = ({ totalPoints }) => {
    return (
        <div className="bg-white rounded-2xl px-6 py-5 shadow-sm w-full flex flex-col items-center text-center">
            <p className="w-full text-left text-xs font-semibold text-gray-500 uppercase tracking-wide">
                Total Points Earned
            </p>
            <p className="text-6xl font-bold text-gray-900 my-4">
                {totalPoints.toLocaleString()}
                <span className="text-base font-medium text-gray-400 ml-1">pts</span>
            </p>
        </div>
    );
};

export default TotalPointsEarnedCard;
